module.exports = __webpack_public_path__ + "img/ask_bg.bf8d8ec0.svg";